var overArg = require('./_overArg');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/lodash/_nativeKeys.js
// module id = 1685
// module chunks = 3 9 13